(function () {
  const sections = document.querySelectorAll('.m-collection-image-showcase');
  if (!sections.length) return;

  // Re-measure whenever anything on the page changes size/height
  let refreshTimeout;
  const debouncedRefresh = () => {
    clearTimeout(refreshTimeout);
    refreshTimeout = setTimeout(() => ScrollTrigger.refresh(), 150);
  };
  new ResizeObserver(debouncedRefresh).observe(document.body);

  sections.forEach((sectionRoot) => {
    let triggers = [];
    let mm = gsap.matchMedia();

    customElements.whenDefined('collection-image-showcase').then(() => {
      const instance = sectionRoot.querySelector('collection-image-showcase');
      if (!instance) return;

      mm.add('(max-width: 767px)', () => {
        const list = sectionRoot.querySelector('.m-collection-image-showcase__collections');
        const media = sectionRoot.querySelector('.m-collection-image-showcase__media');
        const items = sectionRoot.querySelectorAll('.m-collection-image-showcase__collections li');

        if (!list || !media || !items.length) return;

        const activate = (index) => {
          if (instance.currentIndex === index) return;
          instance.setActiveTab(index);
        };

        const pinTrigger = ScrollTrigger.create({
          trigger: list,
          start: 'top top',
          end: 'bottom bottom',
          pin: media,
          pinSpacing: true,
          invalidateOnRefresh: true,
        });

        const itemTriggers = Array.from(items).map((item) => {
          const index = Number(item.dataset.index);
          return ScrollTrigger.create({
            trigger: item,
            start: 'top center',
            end: 'bottom center',
            onEnter: () => activate(index),
            onEnterBack: () => activate(index),
          });
        });

        triggers = [pinTrigger, ...itemTriggers];

        return () => {
          triggers.forEach((t) => t.kill());
          triggers = [];
        };
      });
    });
  });

  window.addEventListener('load', () => ScrollTrigger.refresh());
})();